<div class="form-field mat-form-field-appearance-outline">
  <label class="top-label field-label"
>
  {{ fieldLabel | translate }}
  <span class="walkme-anchor" [attr.walkme-anchor]="fieldLabel"></span>
</label>
  <div class="mat-form-field-wrapper" [attr.aria-busy]="loading || null">
  <!-- Two instances on purpose. Syncfusion's Angular wrapper resolves itemTemplate and
       valueTemplate with @ContentChild('itemTemplate'/'valueTemplate'), NOT with the
       matching @Input: binding them sets the property, then the content query runs,
       finds no matching content child and overwrites it with undefined. So a caller's
       template only survives if it is declared here, inside the element.

       That means a templated instance must be a separate element from the default one -
       an always-present content template would take over item rendering for the callers
       that pass nothing and expect Syncfusion's own renderer. -->
  <ejs-dropdownlist
      *ngIf="!hasCustomTemplate"
      #dropdownField
      id="{{ formControlName }}"
      [fields]="fields"
      (change)="onDropdownChange($event)"
      [placeholder]="placeholder | translate"
      [allowFiltering]="allowFiltering"
      (filtering)="onFiltering($event)"
      cssClass="e-outline"
      [noRecordsTemplate]="noRecordsTemplate | translate"
      [filterType]="'contains'"
      [enableVirtualization]="enableVirtualization"
      [showClearButton]="showClearButton"
      [enabled]="!disabled && !loading"
  ></ejs-dropdownlist>

  <ejs-dropdownlist
      *ngIf="hasCustomTemplate"
      #dropdownField
      id="{{ formControlName }}"
      [fields]="fields"
      (change)="onDropdownChange($event)"
      [placeholder]="placeholder | translate"
      [allowFiltering]="allowFiltering"
      (filtering)="onFiltering($event)"
      cssClass="e-outline tl-templated-ddl"
      [noRecordsTemplate]="noRecordsTemplate | translate"
      [filterType]="'contains'"
      [enableVirtualization]="enableVirtualization"
      [showClearButton]="showClearButton"
      [enabled]="!disabled && !loading"
  >
    <!-- The #itemTemplate / #valueTemplate names are required verbatim - they are the
         ContentChild predicates. customItemTemplate/customValueTemplate are getter
         aliases for the inputs, because the reference variables above shadow the
         identically named component properties inside this element. -->
    <ng-template #itemTemplate let-data>
      <ng-container
        *ngIf="customItemTemplate; else defaultItemT"
        [ngTemplateOutlet]="customItemTemplate"
        [ngTemplateOutletContext]="{ $implicit: data }"
      ></ng-container>
      <ng-template #defaultItemT>{{ defaultText(data) }}</ng-template>
    </ng-template>

    <ng-template #valueTemplate let-data>
      <ng-container
        *ngIf="customValueTemplate; else defaultValueT"
        [ngTemplateOutlet]="customValueTemplate"
        [ngTemplateOutletContext]="{ $implicit: data }"
      ></ng-container>
      <ng-template #defaultValueT>{{ defaultText(data) }}</ng-template>
    </ng-template>
  </ejs-dropdownlist>

  <!-- Sits over the control rather than beside it, so the field keeps its place in the form while
       its options are in flight and nothing below it moves when they land. aria-busy on the wrapper
       is what tells a screen reader; the spinner itself is decorative. -->
  <div *ngIf="loading" class="spinner-overlay" aria-hidden="true">
    <mat-spinner [diameter]="20"></mat-spinner>
  </div>
</div>
</div>
<ng-container *ngIf="debugMode">
  <div>
    <h4>Debug Console</h4>
    <pre class="debug-console">
     selectedValue: {{ selectedValue }}
     initialValue: {{ initialValue }}
  </pre>
  <pre class="debug-console">
    options: {{ options | json }}
  </pre>
  </div>
</ng-container>
